import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';


const CustomSectionItem = ({ children, className }) => (
  <div
    className={classNames(
      'custom-section__item',
      className,
    )}
  >
    {children}
  </div>
);

CustomSectionItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

CustomSectionItem.defaultProps = {
  children: undefined,
  className: undefined,
};

export default CustomSectionItem;
